"use client";

import { useEffect } from "react";
import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunkReload";

// Catches the *uncaught* form of a post-deploy chunk failure: an async import() rejection that
// escapes React and shows in the console as "Uncaught ChunkLoadError … at async Promise.all".
// (The render-thrown form is handled by app/error.tsx — both share one guarded reload.)
//
// Mounted once in the root layout so it covers every route. The customer portal is the most
// exposed surface because each sidebar panel — WalletDashboard, Invoice, verification screens,
// etc. — is a separate dynamic import, so any one of them can hit a stale chunk after a deploy.
export default function ChunkErrorReload() {
  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      if (isChunkLoadError(e.error) || isChunkLoadError({ message: e.message })) {
        reloadOnceForChunkError();
      }
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      if (isChunkLoadError(e.reason)) reloadOnceForChunkError();
    };
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
